import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loading: false,
  metrics: {
    cpuUsage: null,
    memoryUsage: null,
    responseTime: null,
  },
  services: [],
  checkedAt: null,
});

const systemStatusModule = {
  namespaced: true,
  state: initState(),
  mutations: {
    LOADING: (s, data) => (s.loading = data),
    SET_DATA: (s, { metrics, services, checkedAt }) => {
      s.metrics = metrics;
      s.services = services;
      s.checkedAt = checkedAt;
    },
  },
  actions: {
    async getSystemStatus({ commit }) {
      commit("LOADING", true);
      try {
        const { data: res } = await this.$api.get("/v1/portal/system-status");
        commit("SET_DATA", res.data);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADING", false);
      }
    },
  },
};

export default systemStatusModule;
